import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { actions } from '../ducks/explore-arts/explore-arts.slice';
import { ExploreSort, IExploreFilters } from '../ducks/explore-arts/explore-arts.types';
import { selectArts, selectArtsEntities, selectByPage, selectFilter, selectLoading, selectPager, selectPages, selectSorting, selectTotal, selectVisibleTotal } from '../ducks/explore-arts/explore-arts.selectors';
import { fetchArtsThunk } from '../ducks/explore-arts/explore-arts.thunk';


export const useSetPage = () => {
    const dispatch = useAppDispatch();
    return useCallback((page: number) => dispatch(actions.setPage(page)), [dispatch]);
};

export const useClearFilters = () => {
    const dispatch = useAppDispatch();
    return useCallback(() => {
        dispatch(actions.clearFilter());
    }, [dispatch]);
};

export const useClearSorting = () => {
    const dispatch = useAppDispatch();
    return useCallback(() => {
        dispatch(actions.clearSorting());
    }, [dispatch]);
};

export const useClearExplore = () => {
    const dispatch = useAppDispatch();
    return useCallback(() => {
        dispatch(actions.clear());
    }, [dispatch]);
};

export const useIsFiltersApplied = (page: 'explore' | 'collection' | 'profile') => {
    const filters = useFilters();
    return useMemo<boolean>(() => {
        if (
            [
                filters.isPhysical,
                filters.priceRange?.from,
                filters.priceRange?.to
            ].find((el) => el && el.length)
        ) {
            return true;
        }
        return !!(filters.priceRange?.from || filters.priceRange?.to);
    }, [filters, page]);
};

export const useSetFilters = () => {
    const dispatch = useAppDispatch();
    return useCallback((filters: IExploreFilters) => dispatch(actions.setFilter(filters)), [dispatch]);
};

export const useUpdateFilters = () => {
    const dispatch = useAppDispatch();
    return useCallback((filters: IExploreFilters) => dispatch(actions.updateFilter(filters)), [dispatch]);
};

export const useClearItems = () => {
    const dispatch = useAppDispatch();
    return useCallback(() => dispatch(actions.clearItems()), [dispatch]);
};

export const useSetSorting = () => {
    const dispatch = useAppDispatch();
    return useCallback((sorting: ExploreSort) => dispatch(actions.setSorting(sorting)), [dispatch]);
};

export const useFetchExploreArts= () => {
    const dispatch = useAppDispatch();

    return useCallback(async () => {
        const res = await dispatch(fetchArtsThunk());
        return res;
    }, [dispatch]);
};

export const useFilters = () => useAppSelector(selectFilter);
export const useArts = () => useAppSelector(selectArts);
export const useArtsEntities = () => useAppSelector(selectArtsEntities);
export const usePages = () => useAppSelector(selectPages);
export const useArtsByPage = () => useAppSelector(selectByPage);
export const useLoading = () => useAppSelector(selectLoading);
export const useTotal = () => useAppSelector(selectTotal);
export const useSorting = () => useAppSelector(selectSorting);
export const useVisibleTotal = () => useAppSelector(selectVisibleTotal);
export const usePager = () => useAppSelector(selectPager);
